import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || ''

const ESTRELLAS = ['', '★', '★★', '★★★', '★★★★', '★★★★★']
const COLORES = ['', '#e74c3c', '#e67e22', '#f1c40f', '#2ecc71', '#27ae60']

export default function AdminEncuestas() {
  const [datos, setDatos] = useState({ encuestas: [], total: 0, promedio: null })
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const token = localStorage.getItem('token')
    axios.get(`${API}/api/encuestas/`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setDatos(res.data))
      .catch(() => setError('No se pudieron cargar las encuestas.'))
      .finally(() => setCargando(false))
  }, [])

  const distribucion = [5, 4, 3, 2, 1].map(n => ({
    puntuacion: n,
    cantidad: datos.encuestas.filter(e => e.puntuacion === n).length,
  }))
  const maxCantidad = Math.max(...distribucion.map(d => d.cantidad), 1)

  if (cargando) return <div className="loading">Cargando encuestas...</div>

  return (
    <div className="page">
      <div className="page-header">
        <p className="page-label">Panel de administración</p>
        <h1 className="page-title">Encuestas</h1>
        <div className="page-divider"></div>
      </div>

      {error && <div className="error-msg" style={{ marginBottom: '1.5rem' }}>{error}</div>}

      {/* Resumen */}
      <div style={{ display: 'flex', gap: '3rem', marginBottom: '3rem', flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: '3rem', color: 'var(--gold)', fontFamily: 'Cormorant Garamond, serif', fontWeight: 300 }}>
            {datos.promedio ? datos.promedio.toFixed(1) : '—'}
          </div>
          <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
            Puntuación media
          </div>
          {datos.promedio && (
            <div style={{ color: 'var(--gold)', fontSize: '1.2rem', marginTop: '0.25rem' }}>
              {ESTRELLAS[Math.round(datos.promedio)]}
            </div>
          )}
        </div>

        <div>
          <div style={{ fontSize: '3rem', color: 'var(--gold)', fontFamily: 'Cormorant Garamond, serif', fontWeight: 300 }}>
            {datos.total}
          </div>
          <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
            Valoraciones totales
          </div>
        </div>

        {/* Distribución */}
        <div style={{ flex: 1, minWidth: 200 }}>
          {distribucion.map(d => (
            <div key={d.puntuacion} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.4rem' }}>
              <span style={{ fontSize: '0.7rem', color: COLORES[d.puntuacion], width: 24, textAlign: 'right' }}>
                {d.puntuacion}★
              </span>
              <div style={{ flex: 1, height: 8, background: 'var(--dark-3)', borderRadius: 2, overflow: 'hidden' }}>
                <div style={{
                  width: `${(d.cantidad / maxCantidad) * 100}%`,
                  height: '100%',
                  background: COLORES[d.puntuacion],
                  transition: 'width 0.3s',
                }} />
              </div>
              <span style={{ fontSize: '0.65rem', color: 'var(--text-muted)', width: 20 }}>{d.cantidad}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Lista de encuestas */}
      {datos.encuestas.length === 0 ? (
        <div className="empty-state">Todavía no hay valoraciones</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {datos.encuestas.map(e => (
            <div key={e.id} style={{ padding: '1.25rem 1.5rem', background: 'var(--dark-2)', border: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
                <div>
                  <span style={{ color: COLORES[e.puntuacion], fontSize: '1rem' }}>{ESTRELLAS[e.puntuacion]}</span>
                  <span style={{ fontSize: '0.65rem', color: 'var(--text-muted)', marginLeft: '0.75rem' }}>
                    {new Date(e.respondida_en).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </span>
                </div>
              </div>
              {e.comentario && (
                <p style={{ fontSize: '0.8rem', color: 'var(--text)', marginTop: '0.75rem', fontStyle: 'italic', lineHeight: 1.7 }}>
                  "{e.comentario}"
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
